/* eslint-disable no-shadow */
export enum Env {
    PRODUCTION = 'prod',
    DEVELOPMENT = 'dev',
    TEST = 'test'
}
